// Bundle theme module
// To add the classes to the bundle run gulp scripts (before initialisation)
import NSTheme from './NSTheme';
import Menu from './Classes/Menu';
import Dropdown from './Classes/Dropdown';
import Lightbox from './Classes/Lightbox';
import LazyLoad from './lib/lazyload';
import Hyphenation from './Classes/Hyphenation';

module.exports = NSTheme;

(function() {
  document.addEventListener('DOMContentLoaded', function() {

		// code
		const hyphens = new Hyphenation();
		const lightbox = new Lightbox('.ns-img');
		const offcanvas = new Menu();
		const catMenu = new Dropdown(document.querySelector('.cat-menu'));
		const regionMenu = new Dropdown(document.querySelector('.region-menu'));

		new LazyLoad();

		if(document.querySelector('body.admin-bar')){
			document.querySelector('html').classList.add('has-admin-bar');
		}
  });
})();
